import { render, staticRenderFns } from "./Lecturers.vue?vue&type=template&id=6fee0f93&scoped=true"
import script from "./Lecturers.vue?vue&type=script&lang=js"
export * from "./Lecturers.vue?vue&type=script&lang=js"
import style0 from "./Lecturers.vue?vue&type=style&index=0&id=6fee0f93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fee0f93",
  null
  
)

export default component.exports